module.exports = __webpack_public_path__ + "static/img/31.95b5b3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/31.jpg
// module id = ln8R
// module chunks = 0